export default {
    getLoyaltyProducts: state => state.loyalty_products
  }